import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Split from 'react-split-it';

class SampleDataGenerator {
    static generate() {
        return {
            company: {
                name: "ACME Corporation",
                address: "123 Business Park Drive, Suite 100",
                locName: "San Francisco",
                locAddress: "123 street, SF",
                phone: "+1 (555) 123-4567",
                email: "billing@acmecorp.com",
                website: "www.acmecorp.com",
                vatNumber: "VAT-US-12345678",
                registrationNumber: "REG-987654321"
            },

            invoice: {
                number: "INV-2024-01234",
                date: new Date(2024, 5, 15),
                dueDate: new Date(2024, 6, 15),
                deliveryDate: new Date(2024, 5, 14),
                poNumber: "PO-7890123",
                terms: "Net 30",
                currency: "USD"
            },

            customer: {
                firstName: "Sam",
                lastName: "Smith",
                address: "456 Innovation Way, Floor 5",
                city: "Austin",
                state: "TX",
                zip: "78701",
                country: "USA",
                contact: "Sarah Johnson",
                email: "ap@techstart.io",
                phone: "+1 (512) 555-0123",
                vatNumber: "VAT-US-87654321",
                customerId: "CUST-2024-0567",
                EORINumber: "EORI-123"
            },

            items: [
                {
                    code: "DEV-001",
                    description: "Enterprise Software License - Annual",
                    quantity: 1,
                    unitPrice: 12000.00,
                    discount: 10,
                    tax: 20,
                    total: 10800.00,
                    packSize: 8
                },
                {
                    code: "CON-002",
                    description: "Implementation & Training Services",
                    quantity: 40,
                    unitPrice: 150.00,
                    discount: 5,
                    tax: 20,
                    total: 5700.00,
                    packSize: 2
                },
                {
                    code: "SUP-003",
                    description: "Premium Support Package - 12 months",
                    quantity: 1,
                    unitPrice: 3600.00,
                    discount: 0,
                    tax: 20,
                    total: 3600.00,
                    packSize: 5
                },
                {
                    code: "HRD-004",
                    description: "API Gateway Hardware Appliance",
                    quantity: 2,
                    unitPrice: 750.00,
                    discount: 0,
                    tax: 20,
                    total: 1500.00,
                    packSize: 3
                },
                {
                    code: "SVC-005",
                    description: "Data Migration Services",
                    quantity: 15,
                    unitPrice: 125.00,
                    discount: 0,
                    tax: 20,
                    total: 1875.00,
                    packSize: 4
                }
            ],

            totals: {
                subtotal: 23475.00,
                discountTotal: 1575.00,
                taxTotal: 4380.00,
                shipping: 50.00,
                grandTotal: 23905.00,
                paid: 0,
                due: 23905.00
            },

            vatSummary: {
                "20%": {
                    rate: 20,
                    taxableAmount: 21900.00,
                    taxAmount: 4380.00
                }
            },

            bankDetails: {
                bankName: "First International Bank",
                accountName: "ACME Corporation",
                accountNumber: "12345678901",
                sortCode: "12-34-56",
                iban: "GB29 NWBK 6016 1331 9268 19",
                swift: "NWBKGB2L"
            },

            notes: "Thank you for your business. Payment is due within 30 days.",
            termsAndConditions: "1. Goods remain property of ACME until paid in full.\n2. Late payments subject to 1.5% interest per month.\n3. All disputes must be submitted in writing within 14 days."
        };
    }

    static formatDate(date, format) {
        if (!date) return "";
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const hours = String(d.getHours()).padStart(2, '0');
        const minutes = String(d.getMinutes()).padStart(2, '0');
        const seconds = String(d.getSeconds()).padStart(2, '0');

        switch (format) {
            case "YYYY/MM/DD": return `${year}/${month}/${day}`;
            case "YYYY-MM-DD": return `${year}-${month}-${day}`;
            case "YYYY-MM-DD : HH:mm": return `${year}-${month}-${day} ${hours}:${minutes}`;
            case "YYYY-MM-DD : HH:mm:ss": return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            case "DD/MM/YYYY": return `${day}/${month}/${year}`;
            case "MM/DD/YYYY": return `${month}/${day}/${year}`;
            default: return `${year}-${month}-${day}`;
        }
    }

    static formatCurrency(amount) {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount);
    }
}

class InvoicePreview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showPreview: false,
            sampleData: SampleDataGenerator.generate(),
            splitSizes: [0.25, 0.55, 0.1, 0.1],
        };
    }

    componentDidMount() {
        const { heights } = this.props;
        const totalheight = heights.head + heights.body + heights.total + heights.foot;
        this.setState({
            splitSizes: [
                heights.head / totalheight,
                heights.body / totalheight,
                heights.total / totalheight,
                heights.foot / totalheight
            ]
        });
    }

    togglePreview = () => {
        this.setState({ showPreview: !this.state.showPreview });
    };

    resolvePropertyPath = (path, element) => {
        if (!path) return path;

        console.log("path: ", path)
        console.log("element: ", element)
        const { sampleData } = this.state;

        if (path === "CompanyName") return sampleData.company.name;
        if (path === "Address") return sampleData.company.address;
        if (path === "LocationName") return sampleData.company.locName;
        if (path === "LocationAddress") return sampleData.company.locAddress;
        if (path === "PhoneNumber") return sampleData.company.phone;
        if (path === "Email") return sampleData.company.email;
        if (path === "CompanyWeb") return sampleData.company.website;
        if (path === "VATRegistrationNo") return sampleData.company.vatNumber;
        if (path === "CompanyRegistrationNumber") return sampleData.company.registrationNumber;


        if (path === "InvoiceNumber") return sampleData.invoice.number;
        if (path === "InvoiceDate") {
            return SampleDataGenerator.formatDate(sampleData.invoice.date, element?.dateFormat || "YYYY-MM-DD");
        }
        if (path === "InvoiceDueDate") {
            return SampleDataGenerator.formatDate(sampleData.invoice.dueDate, element?.dateFormat || "YYYY-MM-DD");
        }
        if (path === "DeliveryDate") {
            return SampleDataGenerator.formatDate(sampleData.invoice.deliveryDate, element?.dateFormat || "YYYY-MM-DD");
        }
        if (path === "PONumber") return sampleData.invoice.poNumber;
        if (path === "Terms") return sampleData.invoice.terms;


        if (path === "CustomerFirstName") return sampleData.customer.firstName;
        if (path === "CustomerLastName") return sampleData.customer.lastName;
        if (path === "AddressLine1") return sampleData.customer.address;
        if (path === "City") return sampleData.customer.city;
        if (path === "State") return sampleData.customer.state;
        if (path === "Zip") return sampleData.customer.zip;
        if (path === "Country") return sampleData.customer.country;
        if (path === "CustomerContactNumber") return sampleData.customer.phone;
        if (path === "Email") return sampleData.customer.email;
        if (path === "VATNumber") return sampleData.customer.vatNumber;
        if (path === "ContactName") return sampleData.customer.contact;
        if (path === "CustomerID") return sampleData.customer.customerId;
        if (path === "EORINumber") return sampleData.customer.EORINumber;


        if (path === "BankName") return sampleData.bankDetails.bankName;
        if (path === "AccountName") return sampleData.bankDetails.accountName;
        if (path === "AccountNumber") return sampleData.bankDetails.accountNumber;
        if (path === "SortCode") return sampleData.bankDetails.sortCode;
        if (path === "IBAN") return sampleData.bankDetails.iban;
        if (path === "SwiftCode") return sampleData.bankDetails.swift;


        if (path === "VatSummary") {
            return "[VAT_SUMMARY_TABLE]";
        }


        return path;
    };

    renderBodyElements = () => {
        const { sampleData } = this.state;
        const { properties, heights } = this.props;
        const { measureSpec } = this.state;

        const displayData = Object.keys(properties.items.items)
            .map(key => properties.items.items[key])
            .filter(d => d && d.width !== undefined);

        const bodyHeightPercentage = heights.body / 100;
        const pageHeight = properties.prop.orientation === "portrait" ? 297 : 210;
        const marginTop = properties.prop.margin?.top || 0;
        const marginBottom = properties.prop.margin?.bottom || 0;

        const availableBodyHeight = (pageHeight * bodyHeightPercentage) - (marginTop + marginBottom);

        const headerHeight = 32;
        const rowHeight = 41;

        const mmToPx = 3.78;
        const availableBodyHeightPx = availableBodyHeight * mmToPx;

        const totalPossibleRows = Math.floor((availableBodyHeightPx - headerHeight) / rowHeight);
        const sampleDataRows = sampleData.items.length;

        const emptyRowsNeeded = Math.max(0, totalPossibleRows - sampleDataRows);

        return (
            <div style={{
                border: `1px solid ${properties.items.layout.tableBorder}`,
                borderRadius: "4px",
                overflow: "hidden",
                fontFamily: properties.items.layout.itemRow.fontFamily || 'Inter',
                fontSize: `${properties.items.layout.itemRow.fontSize}pt`,
                color: properties.items.layout.itemRow.fontColor,
                height: '100%',
                display: 'flex',
                flexDirection: 'column'
            }}>
                <table style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    tableLayout: 'fixed'
                }}>
                    <thead>
                        <tr style={{ height: `${headerHeight}px` }}>
                            {displayData.map((obj, key) => (
                                <td
                                    key={`preview-h-${key}`}
                                    width={obj.width ? (obj.width / (displayData.reduce((a, v) => a + Number(v.width || 10), 0)) * 100 + "%") : 'auto'}
                                    style={{
                                        padding: "10px 10px 10px 10px",
                                        backgroundColor: properties.items.layout.tableHeader.backgroundColor,
                                        fontSize: `${properties.items.layout.tableHeader.fontSize}pt`,
                                        fontFamily: properties.items.layout.tableHeader.fontFamily,
                                        color: properties.items.layout.tableHeader.fontColor,
                                        borderBottom: `2px solid ${properties.items.layout.tableBorder}`,
                                    }}
                                >
                                    {obj.stringFormat || obj.header}
                                </td>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {sampleData.items.map((item, rowIndex) => (
                            <tr
                                key={`preview-r-${rowIndex}`}
                                style={{
                                    borderBottom: properties.items.layout.itemRow.showHorizontalLines ?
                                        `${properties.items.layout.itemRow.horizontalLineSize}px solid ${properties.items.layout.itemRow.horizontalLineColor}` :
                                        'none',
                                    height: `${rowHeight}px`
                                }}
                            >
                                {displayData.map((column, colIndex) => {
                                    let content = '';

                                    const header = (column.header || '').toLowerCase();

                                    if (header.includes('code') || header.includes('sku') || header.includes('item#')) {
                                        content = item.code;
                                    } else if (header.includes('description') || header.includes('product') || header.includes('service')) {
                                        content = item.description;
                                    } else if (header.includes('qty') || header.includes('quantity')) {
                                        content = item.quantity;
                                    } else if (header.includes('price') || header.includes('rate')) {
                                        content = SampleDataGenerator.formatCurrency(item.unitPrice);
                                    } else if (header.includes('discount')) {
                                        content = item.discount > 0 ? `${item.discount}%` : '-';
                                    } else if (header.includes('tax') || header.includes('vat')) {
                                        content = `${item.tax}%`;
                                    } else if (header.includes('total') || header.includes('amount')) {
                                        content = SampleDataGenerator.formatCurrency(item.total);
                                    } else if (header.includes('PackSize')) {
                                        content = item.packSize;
                                    } else {
                                        content = column.stringFormat || '---';
                                    }



                                    return (
                                        <td
                                            key={`preview-d-${rowIndex}-${colIndex}`}
                                            style={{
                                                padding: "10px 10px 10px 10px",
                                                textAlign: column.textAlign || 'left',
                                                backgroundColor: properties.items.layout.itemRow.backgroundColor,
                                                fontSize: `${properties.items.layout.itemRow.fontSize}pt`,
                                                color: properties.items.layout.itemRow.fontColor,
                                                borderRight: properties.items.layout.itemRow.showVerticleLines ?
                                                    `${properties.items.layout.itemRow.verticleLineSize}px solid ${properties.items.layout.itemRow.verticleLineColor}` :
                                                    'none',
                                                borderLeft: colIndex === 0 && properties.items.layout.itemRow.showVerticleLines ?
                                                    `${properties.items.layout.itemRow.verticleLineSize}px solid ${properties.items.layout.itemRow.verticleLineColor}` :
                                                    'none',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis'
                                            }}
                                        >
                                            {content}
                                        </td>
                                    );
                                })}
                            </tr>
                        ))}

                        {emptyRowsNeeded > 0 && Array.from({ length: emptyRowsNeeded }).map((_, emptyIndex) => (
                            <tr
                                key={`preview-empty-${emptyIndex}`}
                                style={{
                                    borderBottom: properties.items.layout.itemRow.showHorizontalLines ?
                                        `${properties.items.layout.itemRow.horizontalLineSize}px solid ${properties.items.layout.itemRow.horizontalLineColor}` :
                                        'none',
                                    height: `${rowHeight}px`
                                }}
                            >
                                {displayData.map((column, colIndex) => (
                                    <td
                                        key={`preview-empty-${emptyIndex}-${colIndex}`}
                                        style={{
                                            padding: "10px 10px 10px 10px",
                                            textAlign: column.textAlign || 'left',
                                            backgroundColor: properties.items.layout.itemRow.backgroundColor,
                                            fontSize: `${properties.items.layout.itemRow.fontSize}pt`,
                                            color: properties.items.layout.itemRow.fontColor,
                                            borderRight: properties.items.layout.itemRow.showVerticleLines ?
                                                `${properties.items.layout.itemRow.verticleLineSize}px solid ${properties.items.layout.itemRow.verticleLineColor}` :
                                                'none',
                                            borderLeft: colIndex === 0 && properties.items.layout.itemRow.showVerticleLines ?
                                                `${properties.items.layout.itemRow.verticleLineSize}px solid ${properties.items.layout.itemRow.verticleLineColor}` :
                                                'none',
                                        }}
                                    >
                                        &nbsp;
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    };
    renderCompanyElements = () => {
        const { properties } = this.props;

        if (!properties.head?.companyProps) return null;

        return Object.keys(properties.head.companyProps).map(key => {
            const prop = properties.head.companyProps[key];
            if (!prop.show) return null;

            // const resolvedText = this.resolvePropertyPath(prop.data, prop);

            const defaultFontColor = properties.prop.fontColor;
            const defaultFontSize = `${properties.prop.fontSize}pt`;
            const sectionFont = properties.head?.font || {
                fontFamily: 'Inter',
                fontSize: properties.prop.fontSize,
                color: properties.prop.fontColor
            };

            const dStyle = { ...prop.style };
            dStyle.fontFamily = prop.style?.fontFamily || sectionFont.fontFamily || 'Inter';
            if (!dStyle.color) {
                dStyle.color = sectionFont.color || defaultFontColor;
            }
            if (!dStyle.fontSize) {
                dStyle.fontSize = sectionFont.fontSize ? `${sectionFont.fontSize}pt` : defaultFontSize;
            }
            if (!dStyle.fontWeight) {
                dStyle.fontWeight = prop.style?.fontWeight || 'normal';
            }
            if (!dStyle.fontStyle) {
                dStyle.fontStyle = prop.style?.fontStyle || 'normal';
            }
            if (!dStyle.textDecoration) {
                dStyle.textDecoration = prop.style?.textDecoration || 'none';
            }
            if (!dStyle.textAlign) {
                dStyle.textAlign = prop.style?.textAlign || 'left';
            }

            const isList = dStyle.listStyleType && dStyle.listStyleType !== 'none';
            // const textLines = resolvedText ? resolvedText.toString().split('\n') : [''];
            const textLines = prop.data ? prop.data.toString().split('\n') : [''];

            return (
                <div
                    key={`preview-${prop.id}`}
                    style={dStyle}
                >
                    {isList ? (
                        <ul style={{
                            margin: 0,
                            padding: 0,
                            paddingLeft: dStyle.listStyleType === 'decimal' ? '25px' : '20px',
                            listStyleType: dStyle.listStyleType
                        }}>
                            {textLines.map((line, idx) => (
                                <li key={idx} style={{
                                    color: dStyle.color,
                                    fontSize: dStyle.fontSize,
                                    fontFamily: dStyle.fontFamily,
                                    fontWeight: dStyle.fontWeight,
                                    fontStyle: dStyle.fontStyle,
                                    textDecoration: dStyle.textDecoration,
                                    textAlign: dStyle.textAlign,
                                    marginBottom: idx < textLines.length - 1 ? '4px' : '0'
                                }}>
                                    {line || '\u00A0'}
                                </li>
                            ))}
                        </ul>
                    ) : (
                        // resolvedText
                        prop.data
                    )}
                </div>
            );
        });
    };

    renderElements = (section) => {
        const { properties } = this.props;

        if (!properties[section]?.elements) return null;

        return Object.keys(properties[section].elements).map(key => {
            const data = properties[section].elements[key];

            if (section === 'total' && (data.text === "[VAT_SUMMARY_TABLE]" || data.data === "VatSummary")) {
                return (
                    <div key={data.id} style={{ width: '100%' }}>
                        {this.renderVatSummaryTable()}
                    </div>
                );
            }

            // const resolvedText = this.resolvePropertyPath(data.data, data);

            const defaultFontColor = properties.prop.fontColor;
            const defaultFontSize = `${properties.prop.fontSize}pt`;
            const sectionFont = properties[section]?.font || {
                fontFamily: 'Inter',
                fontSize: properties.prop.fontSize,
                color: properties.prop.fontColor
            };

            const dStyle = { ...data.style };
            dStyle.fontFamily = data.style?.fontFamily || sectionFont.fontFamily || 'Inter';
            if (!dStyle.color) {
                dStyle.color = sectionFont.color || defaultFontColor;
            }
            if (!dStyle.fontSize) {
                dStyle.fontSize = sectionFont.fontSize ? `${sectionFont.fontSize}pt` : defaultFontSize;
            }
            if (!dStyle.fontWeight) {
                dStyle.fontWeight = data.style?.fontWeight || 'normal';
            }
            if (!dStyle.fontStyle) {
                dStyle.fontStyle = data.style?.fontStyle || 'normal';
            }
            if (!dStyle.textDecoration) {
                dStyle.textDecoration = data.style?.textDecoration || 'none';
            }
            if (!dStyle.textAlign) {
                dStyle.textAlign = data.style?.textAlign || 'left';
            }

            const isList = dStyle.listStyleType && dStyle.listStyleType !== 'none';
            // const textLines = resolvedText ? resolvedText.split('\n') : [''];
            const textLines = data.text ? data.text.split('\n') : [''];

            return (
                <div
                    key={data.id}
                    style={dStyle}
                >
                    {isList ? (
                        <ul style={{
                            margin: 0,
                            padding: 0,
                            paddingLeft: dStyle.listStyleType === 'decimal' ? '25px' : '20px',
                            listStyleType: dStyle.listStyleType
                        }}>
                            {textLines.map((line, idx) => (
                                <li key={idx} style={{
                                    color: dStyle.color,
                                    fontSize: dStyle.fontSize,
                                    fontFamily: dStyle.fontFamily,
                                    fontWeight: dStyle.fontWeight,
                                    fontStyle: dStyle.fontStyle,
                                    textDecoration: dStyle.textDecoration,
                                    textAlign: dStyle.textAlign,
                                    marginBottom: idx < textLines.length - 1 ? '4px' : '0'
                                }}>
                                    {line || '\u00A0'}
                                </li>
                            ))}
                        </ul>
                    ) : (
                        data.text
                        // resolvedText
                    )}
                </div>
            );
        });
    };

    renderDocumentTitle = () => {
        const { properties } = this.props;

        if (!properties.head?.documentTitle?.show) return null;

        const title = properties.head.documentTitle;
        const defaultFontColor = properties.prop.fontColor;

        const dStyle = { ...title.style };
        if (!dStyle.color) {
            dStyle.color = defaultFontColor;
        }
        if (!dStyle.fontFamily && properties.head?.font?.fontFamily) {
            dStyle.fontFamily = properties.head.font.fontFamily;
        } else if (!dStyle.fontFamily) {
            dStyle.fontFamily = 'Inter';
        }
        if (!dStyle.fontSize) {
            dStyle.fontSize = "20pt";
        }
        if (!dStyle.fontWeight) {
            dStyle.fontWeight = title.style?.fontWeight || 'bold';
        }
        if (!dStyle.fontStyle) {
            dStyle.fontStyle = title.style?.fontStyle || 'normal';
        }
        if (!dStyle.textDecoration) {
            dStyle.textDecoration = title.style?.textDecoration || 'none';
        }
        if (!dStyle.textAlign) {
            dStyle.textAlign = title.style?.textAlign || 'center';
        }

        return (
            <div
                key={title.id}
                style={dStyle}
            >
                {title.title}
            </div>
        );
    };

    renderImage = (section) => {
        const { properties } = this.props;

        if (!properties.head?.logo || Object.keys(properties.head.logo).length === 0) return null;

        const logoStyle = { ...properties.head.logo.style, zIndex: 0 };

        return properties.head.logo.showLogo && properties.head.logo.logo ? (
            <div
                style={logoStyle}
                key={properties.head.logo.id}
            >
                <div>
                    <img
                        src={properties.head.logo.logo}
                        style={{
                            width: `${properties.head.logo.logoSize}%`,
                        }}
                        alt="Company logo"
                    />
                </div>
            </div>
        ) : null;
    };

    renderShapes = (section) => {
        const { properties } = this.props;

        if (!properties[section]?.shapes || Object.keys(properties[section].shapes).length === 0) return null;

        return Object.keys(properties[section].shapes)
            .filter(s => s !== 'border')
            .map(key => {
                const data = properties[section].shapes[key];
                const font = properties[section]?.font || { fontFamily: 'Inter', fontSize: 10 };
                const borderColor = properties[section].shapes.border.color;
                const borderSize = properties[section].shapes.border.size;
                const bgColor = properties[section].shapes.border.fillColor;

                const dStyle = {
                    ...data.style,
                    minWidth: '32px',
                    minHeight: '16px',
                    border: `${borderSize}px solid ${borderColor}`,
                    background: bgColor,
                    // zIndex: 0
                };

                return (
                    <div
                        key={data.id}
                        style={{ ...dStyle, ...font }}
                    />
                );
            });
    };

    renderVatSummaryElement = () => {
        const { properties } = this.props;

        if (!properties.total?.VatSummary || Object.keys(properties.total.VatSummary).length === 0) return null;

        const data = properties.total.VatSummary;
        const defaultFontColor = properties.prop.fontColor;
        const defaultFontSize = `${properties.prop.fontSize}pt`;
        const sectionFont = properties.total?.font || {
            fontFamily: 'Inter',
            fontSize: properties.prop.fontSize,
            color: properties.prop.fontColor
        };

        const dStyle = { ...data.style };
        dStyle.width = '100%';
        dStyle.height = 'auto';
        dStyle.fontFamily = data.style?.fontFamily || sectionFont.fontFamily || 'Inter';

        if (!dStyle.color) {
            dStyle.color = sectionFont.color || defaultFontColor;
        }
        if (!dStyle.fontSize) {
            dStyle.fontSize = sectionFont.fontSize ? `${sectionFont.fontSize}pt` : defaultFontSize;
        }
        if (!dStyle.fontWeight) {
            dStyle.fontWeight = data.style?.fontWeight || 'normal';
        }
        if (!dStyle.fontStyle) {
            dStyle.fontStyle = data.style?.fontStyle || 'normal';
        }
        if (!dStyle.textDecoration) {
            dStyle.textDecoration = data.style?.textDecoration || 'none';
        }
        if (!dStyle.textAlign) {
            dStyle.textAlign = data.style?.textAlign || 'left';
        }

        if (data.text === "[VAT_SUMMARY_TABLE]" || data.data === "VatSummary") {
            return (
                <div key={data.id} style={dStyle}>
                    {this.renderVatSummaryTable()}
                </div>
            );
        }

        const isList = dStyle.listStyleType && dStyle.listStyleType !== 'none';
        const textLines = data.text ? data.text.split('\n') : [''];

        return (
            <div
                key={data.id}
                style={dStyle}
            >
                {isList ? (
                    <ul style={{
                        margin: 0,
                        padding: 0,
                        paddingLeft: dStyle.listStyleType === 'decimal' ? '25px' : '20px',
                        listStyleType: dStyle.listStyleType
                    }}>
                        {textLines.map((line, idx) => (
                            <li key={idx} style={{
                                color: dStyle.color,
                                fontSize: dStyle.fontSize,
                                fontFamily: dStyle.fontFamily,
                                fontWeight: dStyle.fontWeight,
                                fontStyle: dStyle.fontStyle,
                                textDecoration: dStyle.textDecoration,
                                textAlign: dStyle.textAlign,
                                marginBottom: idx < textLines.length - 1 ? '4px' : '0'
                            }}>
                                {line || '\u00A0'}
                            </li>
                        ))}
                    </ul>
                ) : (
                    data.text
                )}
            </div>
        );
    };

    renderVatSummaryTable = () => {
        const { properties } = this.props;

        const vatData = [
            { VatCode: 'S', VatPercentage: 20, GoodsValue: 15000.00, VatValue: 3000.00 },
            // { VatCode: 'Z', VatPercentage: 0, GoodsValue: 8475.00, VatValue: 0.00 },
            // { VatCode: 'E', VatPercentage: 5, GoodsValue: 5000.00, VatValue: 250.00 }
        ];

        const totalGoods = vatData.reduce((sum, item) => sum + item.GoodsValue, 0);
        const totalVat = vatData.reduce((sum, item) => sum + item.VatValue, 0);

        const totalSection = properties.total || {};
        const fontConfig = totalSection.font || {};
        const vatSummaryConfig = totalSection.VatSummary || {};
        const vatSummaryStyle = vatSummaryConfig.style || {};

        const fontSize = vatSummaryStyle.fontSize || fontConfig.fontSize || 10;
        const fontFamily = vatSummaryStyle.fontFamily || fontConfig.fontFamily || 'Inter';
        const color = vatSummaryStyle.color || fontConfig.color || '#333333';
        const backgroundColor = vatSummaryStyle.backgroundColor || '#ffffff';
        const headerBgColor = vatSummaryStyle.headerBackgroundColor || '#ffffff';
        const borderColor = vatSummaryStyle.borderColor || '#eeeeee';
        const headerPadding = "10pt"
        const rowHeight = fontSize + 8;
        const headerHeight = rowHeight + parseInt(headerPadding);

        const tableStyle = {
            width: '240pt',
            borderCollapse: 'collapse',
            fontFamily: fontFamily,
            fontSize: `${fontSize}pt`,
            color: color,
            backgroundColor: backgroundColor,
            border: `1px solid ${borderColor}`,
            marginTop: '10px',
            marginBottom: '10px'
        };

        const thStyle = {
            width: '25%',
            backgroundColor: headerBgColor,
            paddingLeft: '5px',
            height: headerHeight,
            textAlign: 'left',
            borderBottom: `2px solid ${borderColor}`,
            borderRight: `1px solid ${borderColor}`,
            fontWeight: 'bold'
        };

        const tdStyle = {
            width: '25%',
            height: rowHeight,
            padding: '0 5px',
            borderBottom: `1px solid ${borderColor}`,
            borderRight: `1px solid ${borderColor}`
        };

        return (
            <table style={tableStyle}>
                <thead>
                    <tr>
                        <th style={thStyle}>Vat Code</th>
                        <th style={thStyle}>Vat Rate</th>
                        <th style={{ ...thStyle, textAlign: 'left', paddingRight: 0 }}>Good Values</th>
                        <th style={{ ...thStyle, textAlign: 'left', borderRight: 'none' }}>Vat</th>
                    </tr>
                </thead>
                <tbody>
                    {vatData.map((item, index) => (
                        <tr key={`vat-row-${index}`}>
                            <td style={tdStyle}>{item.VatCode}</td>
                            <td style={tdStyle}>{item.VatPercentage}%</td>
                            <td style={{ ...tdStyle, textAlign: 'right' }}>
                                {item.GoodsValue}
                            </td>
                            <td style={{ ...tdStyle, textAlign: 'right', borderRight: 'none' }}>
                                {item.VatValue}
                            </td>
                        </tr>
                    ))}
                    <tr style={{ backgroundColor: headerBgColor, fontWeight: 'bold' }}>
                        <td style={{ ...tdStyle, borderRight: `1px solid ${borderColor}`, fontWeight: 'bold' }}>
                            Totals
                        </td>
                        <td style={{ ...tdStyle, borderRight: `1px solid ${borderColor}`, fontWeight: 'bold' }}></td>
                        <td style={{ ...tdStyle, textAlign: 'right', fontWeight: 'bold' }}>
                            {totalGoods}
                        </td>
                        <td style={{ ...tdStyle, textAlign: 'right', borderRight: 'none', fontWeight: 'bold' }}>
                            {totalVat}
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    };

    renderPreviewCanvas = () => {
        const { properties, heights } = this.props;

        const totalheight = heights.head + heights.body + heights.total + heights.foot;
        const splitSizes = [
            heights.head / totalheight,
            heights.body / totalheight,
            heights.total / totalheight,
            heights.foot / totalheight
        ];

        const [headHeight, bodyHeight, totalHeight, footHeight] = splitSizes.map(s => `${(s * 100).toFixed(4)}%`);

        const pageStyle = properties.prop.orientation === "portrait"
            ? { width: '210mm', height: '297mm' }
            : { width: '297mm', height: '210mm' };

        return (
            <div
                className="canves"
                style={pageStyle}
            >
                <div
                    className="canves-content"
                    style={{
                        backgroundColor: properties.prop.background.showColor
                            ? properties.prop.background.color
                            : "white",
                        width: pageStyle.width,
                        height: pageStyle.height,
                        position: 'relative',
                        boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px"
                    }}
                >
                    {properties.prop.background.showImage && properties.prop.background.image && (
                        <div
                            className="background-image-layer"
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundImage: `url(${properties.prop.background.image})`,
                                backgroundSize: properties.prop.background.imageSize
                                    ? `${properties.prop.background.imageSize}%`
                                    : 'cover',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                                opacity: properties.prop.background.opacity || 1,
                                zIndex: 0,
                            }}
                        />
                    )}

                    <div className="content-container" style={{ position: 'relative', zIndex: 1, height: '100%' }}>
                        <div id="templateContainer" style={{ height: '100%' }}>
                            <div className="simple-vertical" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                                {/* <Split
                                    className="split-vertical"
                                    style={properties.prop.orientation === "portrait" ? { height: '297mm' } : { height: '210mm' }}
                                    direction="vertical"
                                    sizes={splitSizes}
                                    gutterSize={0}
                                    allowResize={false}
                                > */}
                                <div
                                    className="content canves-header"
                                    style={{
                                        height: headHeight,
                                        flexShrink: 0,
                                        overflow: 'hidden',
                                        backgroundColor: properties.head.background.showColor
                                            ? properties.head.background.color
                                            : "transparent",
                                    }}
                                >
                                    <div
                                        className="canves-content-children"
                                        style={{
                                            marginTop: properties.prop.margin ? `${properties.prop.margin.top}in` : '1in',
                                            marginLeft: properties.prop.margin ? `${properties.prop.margin.left}in` : '1in',
                                            marginRight: properties.prop.margin ? `${properties.prop.margin.right}in` : '1in',
                                            borderBottom: 0,
                                        }}
                                    >
                                        <div>
                                            {this.renderShapes("head")}
                                            {this.renderCompanyElements()}
                                            {this.renderElements("head")}
                                            {this.renderImage("head")}
                                            {this.renderDocumentTitle()}
                                        </div>
                                    </div>
                                </div>

                                <div
                                    className="content canves-body"
                                    style={{
                                        height: bodyHeight,
                                        flexShrink: 0,
                                        position: 'relative',
                                        overflow: 'hidden',
                                    }}
                                >
                                    <div
                                        className="canves-content-children"
                                        style={{
                                            marginLeft: properties.prop.margin ? `${properties.prop.margin.left}in` : '1in',
                                            marginRight: properties.prop.margin ? `${properties.prop.margin.right}in` : '1in',
                                            overflow: "hidden",
                                            borderTop: 0,
                                            borderBottom: 0,
                                        }}
                                    >
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                right: 0,
                                                bottom: 0,
                                                marginLeft: `${properties.prop.margin.left}in`,
                                                marginRight: `${properties.prop.margin.right}in`
                                            }}
                                        >
                                            {this.renderBodyElements()}
                                        </div>
                                    </div>
                                </div>

                                <div
                                    className="content canves-total"
                                    style={{
                                        height: totalHeight,
                                        flexShrink: 0,
                                        overflow: 'hidden',
                                        backgroundColor: properties.total.background.showColor
                                            ? properties.total.background.color
                                            : "transparent",
                                    }}
                                >
                                    <div className="canves-content-children">
                                        <div style={{ position: "absolute" }}>
                                            {this.renderElements("total")}
                                            {this.renderVatSummaryElement()}
                                            {this.renderShapes("total")}
                                        </div>
                                    </div>
                                </div>

                                <div
                                    className="content canves-footer"
                                    style={{
                                        height: footHeight,
                                        flexShrink: 0,
                                        overflow: 'hidden',
                                        backgroundColor: properties.foot.background.showColor
                                            ? properties.foot.background.color
                                            : "transparent",
                                    }}
                                >
                                    <div className="canves-content-children">
                                        <div style={{ position: "absolute" }}>
                                            {this.renderElements("foot")}
                                            {this.renderShapes("foot")}
                                        </div>
                                    </div>
                                </div>
                                {/* </Split> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    render() {
        return (
            <>
                <Button
                    variant="outline-primary"
                    onClick={this.togglePreview}
                    title="Preview Invoice"
                    style={{ marginRight: '10px' }}
                >
                    <FontAwesomeIcon icon="eye" className="me-2" />
                    Preview
                </Button>

                <Modal
                    show={this.state.showPreview}
                    onHide={this.togglePreview}
                    size="xl"
                    fullscreen
                    style={{ zIndex: 10700 }}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Invoice Preview</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div
                            className="preview-wrapper"
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'flex-start',
                                padding: '20px',
                                backgroundColor: '#f5f5f5',
                                minHeight: 'calc(100vh - 120px)',
                                overflow: 'auto'
                            }}
                        >
                            {this.renderPreviewCanvas()}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="text-muted me-auto">
                            <small>Preview shows template layout exactly as configured.</small>
                        </div>
                        <Button variant="secondary" onClick={this.togglePreview}>
                            Close Preview
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    properties: {
        prop: state.template.prop,
        head: state.template.head,
        items: state.template.items,
        total: state.template.total,
        foot: state.template.foot
    },
    heights: state.template.heights
});

export default connect(mapStateToProps, null)(InvoicePreview);